

















































































































































































































import Vue from 'vue'
import NumberField from '@/components/NumberField.vue'
import WarningDialog from '@/components/WarningDialog.vue'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

interface ComponentData {
  loading: boolean
  rules: Function[]
  validationRules: Function[]
  menu1: boolean
  date: string
  dateFormatted: string | null
  dateRules: any[]
  time: string | null
  timeRules:  Function[]

  employeeList: any[]
  eingangViaList: any[]
  verantwortlich: any | null
  eingangVia: any | null
  anrede: any | null
  vorname: any | null
  name: any | null
  strasse: any | null
  hausnummer: any | null
  PLZ: any | null
  ort: any | null
  land: any | null
  kanton: any | null
  mobilePhone: any | null
  email: any | null
  businessEmail: any | null
  phone: any | null
  phonePlus: any | null
  whatsApp: any | null
  bemerkung: any | null

  isMobilePhoneEdit: boolean
  isMailEdit: boolean
  isBusinessMailEdit: boolean
  isPhoneEdit: boolean
  isPhonePlusEdit: boolean
  isWhatsAppEdit: boolean
}

export default Vue.extend({
  name: 'KanbanDialog',

  components: {
    NumberField,
    WarningDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    isKanbanCreate: Boolean,
    kanbanDialogLabel: String,
    data: Object as () => any
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || ''

    return {
      loading: false,
      rules: [(value: any): boolean | string => !!value || ''],
      validationRules: [required],
      menu1: false,
      date: '',
      dateFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        }
      ],
      time: null,
      timeRules: [
        (v: string): boolean | string => !!v || this.$t('errors.required').toString()
      ],

      employeeList: [],
      eingangViaList: [],
      verantwortlich: null,
      eingangVia: null,
      anrede: null,
      vorname: null,
      name: null,
      strasse: null,
      hausnummer: null,
      PLZ: null,
      ort: null,
      land: null,
      kanton: null,
      mobilePhone: null,
      email: null,
      businessEmail: null,
      phone: null,
      phonePlus: null,
      whatsApp: null,
      bemerkung: null,


      isMobilePhoneEdit: false,
      isMailEdit: false,
      isBusinessMailEdit: false,
      isPhoneEdit: false,
      isPhonePlusEdit: false,
      isWhatsAppEdit: false
    }
  },

  watch : {
    dateFormatted (newVal: string | null): void {
      if(newVal) {
        this.date = moment(newVal, 'DD.MM.YYYY').isValid() ?  moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.date = ''
      }
    },
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    getCurrentDateTime (): string {
      return  moment().format('DD.MM.YYYY HH:mm')
    },
  },

  methods: {
    onDateChange (date: string): void {
      this.dateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurDate (): void {
      this.dateFormatted = moment(this.date).isValid() ?  moment(this.date).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onRecruitingButtonClick (): void {
      this.$emit('showRecruiting')
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if(form.validate()) {
        //this.showWarningDialog = true
      }
    },

    onWarningDialogClose (): void {
      //this.showWarningDialog = false
    },

    onWarningDialogSave (): void {
      //this.showWarningDialog = false
      this.$emit('save')
    }
  },

  mounted() {
    if(!this.isKanbanCreate) {
      this.vorname = this.data.vorname
      this.name = this.data.name
    }
  }
})
